import { GA_INTAKE_CATEGORY } from './generalEvents';

export const INTAKE_GA = {
  category: GA_INTAKE_CATEGORY,
  events: {
    treatment_q_viewed: 'Treatment q viewed intake',
    treatment_q_not_received_clicked: 'Treatment q didn’t received clicked intake',
    treatment_q_drug_added: 'Treatment q drug added intake',
    treatment_q_combination_added: 'Treatment q combination added intake',
    treatment_q_treatment_answered: 'Treatment q treatment answered intake',
    treatment_q_cycles_answered: 'Treatment q cycles answered intake',
    treatment_q_timing_answered: 'Treatment q timing answered  intake',
    treatment_q_reason_answered: 'Treatment q reason answered  intake',
    treatment_q_add_more_clicked: 'Treatment q add more clicked intake',
    treatment_q_next_clicked: 'Treatment q next clicked intake',
  },
};
